import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import { CLIENTS_QUOTAS_QUERY_KEY, QUOTA_QUERY_KEY } from "~/modules/client/api/quota/quotaQueries.ts";
import type { QuotaWithRelations } from "~/modules/client/api/quota/quotaTypes.ts";
import UpdateQuotaInvoicingDetailsForm
	from "~/modules/client/components/quota/QuotaDetailsView/components/UpdateQuotaInvoicingDetailsSidebar/UpdateQuotaInvoicingDetailsForm.tsx";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	quota: QuotaWithRelations
};

const UpdateQuotaInvoicingDetailsSidebar = ({
	isOpen,
	onClose,
	quota,
}: Props) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: QUOTA_QUERY_KEY(quota.id) });
		await queryClient.invalidateQueries({ queryKey: CLIENTS_QUOTAS_QUERY_KEY(quota.clientId) });
		await queryClient.invalidateQueries();
		onClose();
	}, [onClose, queryClient, quota.clientId, quota.id]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && <UpdateQuotaInvoicingDetailsForm
				onCancel={onClose}
														onSuccess={handleSuccess}
														quota={quota} />}
		</Sidebar>
	);
};

export default UpdateQuotaInvoicingDetailsSidebar;
